import styled, {css} from "styled-components"
import {Modal} from "react-bootstrap/lib"

import Card from "@irati/ui/src/Layout/Card"
import Flex from "@irati/ui/src/Flex"

export const RowInfo = styled(Flex)`
  ${({theme}) => css`
    border-top: 1px solid ${theme.colors.greys.light};
    &:last-child {
      border-bottom: 1px solid ${theme.colors.greys.light};
    }
    > p {
      flex-basis: 50%;
    }
  `}
`
export const CustomModal = styled(Modal)`
  .modal-dialog {
    width: 850px;
    .modal-content {
      border-radius: ${({theme}) => theme.spacing.two};
    }
  }
`
export const CustomCard = styled(Card)`
  border-radius: ${({theme}) => `${theme.spacing.oneAndHalf} ${theme.spacing.oneAndHalf} 0 0`};
`
